import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import SideNav from "../Layout/SideNav";
import {
  makeStyles,
  createStyles,
  useTheme,
  withStyles,
} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import SearchBar from "material-ui-search-bar";
import Divider from "@material-ui/core/Divider";
import Chip from "@material-ui/core/Chip";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import Button from "@material-ui/core/Button";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import EditIcon from "@material-ui/icons/Edit";
import * as moment from "moment";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import $ from "jquery";
import styled from "styled-components";
import { Pagination } from "@mui/material";
import { EmailOutlined } from "@material-ui/icons";
import { DraftsOutlined } from "@material-ui/icons";
import Loader from "react-loader-spinner";
import { displayAlertifyError } from "../../util/functions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const formatCurrency = (number) => {
  return parseFloat(number).toLocaleString(undefined, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });
};
const StyledTableContainer = withStyles((theme) => ({
  root: {
    width: "max-content",
  },
}))(TableContainer);

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
    flexGrow: 1,
  },
  divider: {
    // Theme Color, or use css color in quote
    background: "#000",
  },
}));

const usePaginate = makeStyles(() => ({
  ul: {
    "& .MuiPaginationItem-root.Mui-selected": {
      color: "#FFF",
      backgroundColor: "#FC3538 !important",
    },
    "& .MuiPaginationItem-root.Mui-selected:hover": {
      color: "#FFF",
      backgroundColor: "#FC3538 !important",
    },
  },
}));

const styles = (theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DivEstimateHead = styled.div`
  background-color: white;
  padding-left: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

const DivPagination = styled.div`
  padding: 30px 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .css-bf9wz-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {
    color: #fff;
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 1);
    background-color: #fc3538;
    &:hover {
      background-color: #fc3538;
    }
  }
`;
const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function Estimate(props) {
  let get_token = localStorage.getItem("Token");
  let get_userid = localStorage.getItem("user_id");
  let user_status = localStorage.getItem("user_id");
  const estimateStatus = localStorage.getItem("estimateStatus");

  const [host, setHost] = useState(APIModel.HOST);
  const [token, setToken] = useState(get_token);
  const [userid, setUserId] = useState(get_userid);
  const [estimates, setEstimates] = useState([]);

  const [count, setCount] = useState(0);
  const [status, setStatus] = useState(Number(estimateStatus) || 0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [total, setTotal] = useState(0);

  const [search, setSearch] = useState("");
  const [searching, setSearching] = useState(false);
  const [foundEstimates, setFoundEstimates] = useState(estimates);
  const [noResult, setNoResult] = useState(false);
  const [loading, setLoading] = useState(true);

  const [totalPages, setTotalPages] = useState(0);
  const [selectedPage, setSelectedpage] = useState(1);

  const classes = useStyles();
  const paginations = usePaginate();
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const [open, setOpen] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const handlefilterSearch = (value) => {
    setSearch(value);
    if (!searching && value !== "") setSearching(true);
    else if (searching && value === "") setSearching(false);
  };

  const filter = async () => {
    setTimeout(() => {
      setLoading(true);
    }, 500);
    setNoResult(true);
    let params = { userid: userid, status: status, search: search };
    await axios
      .post(host + "get-search-estimates?page=" + selectedPage, params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        var groups = {};
        setTotalPages(response.data.estimates.last_page);
        let newTotal = 0;
        response.data.estimates.data.forEach(function (val) {
          var date = val.date;
          newTotal += val.total;
          if (date in groups) {
            groups[date].push(val);
          } else {
            groups[date] = new Array(val);
          }
        });
        setTotal(newTotal);
        setFoundEstimates(groups);
      })
      .catch(function (error) {
        displayAlertifyError({
          error: "There is a problem in your network connection",
        });
      });
    setLoading(false);
  };

  const getEstimates = async () => {
    // setTimeout(()=>{
    //     setLoading(true);
    // }, 500)
    setLoading(true);
    let params = { userid: userid, status: status };
    await axios
      .post(host + "get-estimates?page=" + selectedPage, params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setTotal(0);
        // setEstimates(response.data.estimates);
        // setFoundEstimates(response.data.estimates);
        // response.data.estimates.map((item, index) => (
        //     console.log(item)
        // ))
        var groups = {};
        setTotalPages(response.data.estimates.last_page);
        let newTotal = 0;
        if (response.data.status === true) {
          response.data.estimates.data.forEach(function (val) {
            newTotal += val.total;
            var date = moment(val.date).format("YYYY-MM");
            if (date in groups) {
              groups[date].push(val);
            } else {
              groups[date] = new Array(val);
            }
          });
          setTotal(newTotal);
          setEstimates(groups);
          setFoundEstimates(groups);
        } else {
          setEstimates([]);
          setFoundEstimates([]);
          displayAlertifyError({ error: "No data available" });
        }
      })
      .catch(function (error) {
        displayAlertifyError({ error: "No data available" });
      });
    setLoading(false);
  };

  function allFilter() {
    setFoundEstimates(estimates);
  }

  function handleClickOpen() {
    setOpen(true);
  }
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    searching ? filter() : getEstimates();
  }, [count, selectedPage, status, searching, search]);

  useEffect(() => {
    setSelectedpage(1);
  }, [status, searching]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [selectedPage]);

  useEffect(() => {
    const estimateStatus = localStorage.getItem("estimateStatus");
    if (estimateStatus) {
      setStatus(Number(estimateStatus));
      setValue(Number(estimateStatus));
    }
  }, []);

  const getStatus = (status) => {
    localStorage.setItem("estimateStatus", status);
    setStatus(status);
    setSelectedpage(1);
  };

  // function getActiveData(status){
  //     setTotal(0);
  //     setStatus(status);
  //     let params = {'userid': userid,'status': status};
  //     axios.post(host +"get-estimates", params, {
  //         'headers': {
  //             'Content-Type': 'application/json',
  //             'Accept': 'application/json',
  //             Authorization: "Bearer " + token,
  //         }
  //     })
  //     .then(response => {
  //         var groups = {};
  //         let newTotal = 0;
  //         response.data.estimates.data.forEach(function(val) {
  //             newTotal += val.total;
  //             var date = moment(val.date).format("YYYY-MM");
  //             if (date in groups) {
  //                 groups[date].push(val);
  //                 console.log(groups);
  //             } else {
  //                 groups[date] = new Array(val);
  //             }
  //         });
  //         setTotal(newTotal);
  //         console.log(groups);
  //         setEstimates(groups);
  //         setFoundEstimates(groups)
  //     })
  //     .catch(function (error) {
  //         displayAlertifyError({error: error});
  //     })
  // }
  const getTitle = (status, total) => {
    if (status === 1) {
        return "Total Amount: " + formatCurrency(total);
    } 
    else if (status === 2) {
      return "Total Amount: " + formatCurrency(total); // Replace with appropriate title
  }
    else {
        return "Total Amount: " + formatCurrency(total);
    }
}
  function exportEstimates() {
    let fromVal = $("#fromDate").val();
    setFromDate(fromVal);
    let toVal = $("#toDate").val();
    setToDate(toVal);

    if (fromVal === "" || fromVal === undefined) {
      displayAlertifyError({ error: "Please select from date" });
      return false;
    }
    if (toVal === "" || toVal === undefined) {
      displayAlertifyError({ error: "Please select to date" });
      return false;
    }
    let params = {
      userid: userid,
      status: status,
      from_date: fromDate,
      to_date: toDate,
    };

    axios
      .post(host + "export-estimates", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setOpen(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "estimates.csv"); //or any other extension
        document.body.appendChild(link);
        link.click();
        alertify.success("Successfully Download Excel");
        setFromDate("");
        setToDate("");
      });
  }
  const handlePagination = (event, value) => setSelectedpage(value);

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <SideNav />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <DivEstimateHead
                  className="py-2 px-2"
                  style={{ borderRadius: "6px" }}
                >
                  <h3 className="font-weight-bold my-0">Estimates</h3>
                  <div>
                    <Link
                      onClick={() => {
                        handleClickOpen();
                      }}
                      className="btn btn-primary pull-right mr-2"
                    >
                      Export
                    </Link>
                    <Link
                      to="/estimates/new"
                      className="btn btn-primary pull-right mr-2"
                    >
                      New Estimate
                    </Link>
                    {/* <Link to="/estimates/lien-form" className="btn btn-primary pull-right mr-2">Estimate Lien Form</Link> */}
                  </div>
                </DivEstimateHead>
                <div className="row">
                  <div className="col-md-12 mb-3 mt-3">
                    <SearchBar
                      placeholder="Search all estimates"
                      value={search}
                      onChange={handlefilterSearch}
                      onCancelSearch={() => handlefilterSearch("")}
                    />
                  </div>
                  <div className="col-md-6">
                    <Dialog
                      onClose={handleClose}
                      aria-labelledby="customized-dialog-title"
                      open={open}
                      maxWidth="sm"
                    >
                      <DialogTitle
                        id="customized-dialog-title"
                        onClose={handleClose}
                      >
                        Export Estimates Data
                      </DialogTitle>
                      <DialogContent dividers style={{ width: "350px" }}>
                        <form enctype="multipart/form-data">
                          <div className="form-group">
                            <label className="mdc-floating-label--shake">
                              From
                            </label>
                            <input
                              type="date"
                              className="form-control input-box"
                              id="fromDate"
                              name="fromDate"
                              required="required"
                              value={fromDate}
                              onChange={(e) => setFromDate(e.target.value)}
                            />
                          </div>
                          <div className="form-group">
                            <label className="mdc-floating-label--shake">
                              To
                            </label>
                            <input
                              type="date"
                              className="form-control input-box"
                              id="toDate"
                              name="toDate"
                              required="required"
                              value={toDate}
                              onChange={(e) => setToDate(e.target.value)}
                            />
                          </div>
                        </form>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          className="btn btn-primary"
                          onClick={() => {
                            exportEstimates();
                          }}
                        >
                          Export Data
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </div>
                <div className={classes.root}>
                  <AppBar position="static" color="default" width={40}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: "#FC3538",
                        },
                      }}
                      textColor="secondary"
                      aria-label="full width tabs example"
                    >
                      <Tab
                        label="Pending"
                        {...a11yProps(0)}
                        onClick={() => getStatus(0)}
                      />
                      <Tab
                        label="Approved"
                        {...a11yProps(1)}
                        onClick={() => getStatus(1)}
                      />
                      <Tab
                        label="Declined"
                        {...a11yProps(2)}
                        onClick={() => getStatus(2)}
                      />
                    </Tabs>
                  </AppBar>
                  <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                      <TableBody>
                        {!loading ? (
                          foundEstimates &&
                            Object.keys(foundEstimates).length > 0 ? (
                            Object.keys(foundEstimates)
                              .sort((a, b) => b.localeCompare(a))
                              .map((items) => (
                                <div key={items} className="container-fluid">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <Typography
                                        style={{ color: "black" }}
                                        variant="h6"
                                        className="float-left mt-3"
                                      >
                                        {moment(items).format("MMMM YYYY")}
                                      </Typography>
                                    </div>
                                    {Object.keys(foundEstimates)[0] ===
                                      items ? (
                                      <div className="col-md-6 mt-3">
                                        <Typography
                                          style={{ paddingRight: "15px" }}
                                          variant="h6"
                                          className="float-right"
                                        >
                                         {getTitle(status, total)}
                                        </Typography>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <Divider
                                    classes={{ root: classes.divider }}
                                    className="mt-3"
                                  />
                                  <div className="row">
                                    <div className="col-md-12">
                                      <Table className={classes.table}>
                                        <TableBody>
                                      {foundEstimates[items]
                                        .sort((a, b) =>
                                          b.date.localeCompare(a.date)
                                        )
                                        .map((item, key) => (
                                          <TableRow key={key}>
                                            <TableCell style={{ width: "30%" }}>
                                              <Link to={`/estimates/view/${item.id}`}>
                                                {item.name} - #{item.id}
                                              </Link>
                                              {
                                item.email_status === 1 ? (
                                  <DraftsOutlined
                                    style={{
                                      position: "relative",
                                      top: "5px",
                                      left: "5px",
                                    }}
                                    htmlColor="#FC3538"
                                    fontSize="small"
                                  />
                                ) : item.email_sent === 1 ? (
                                  <EmailOutlined
                                    style={{
                                      position: "relative",
                                      top: "5px",
                                      left: "5px",
                                    }}
                                    htmlColor="#FC3538"
                                    fontSize="small"
                                  />
                                ) : (
                                  ""
                                )
                              }

                                              <p
                                                style={{
                                                  padding: "0px",
                                                  margin: "0px",
                                                }}
                                              >
                                                PO Number: {item.po_number}
                                              </p>
                                              <p style={{ color: "#999" }}>
                                                {moment(item.date).format(
                                                  "MMMM DD, YYYY"
                                                )}
                                              </p>
                                            </TableCell>
                                            <TableCell>
                                              {(() => {
                                                switch (item.status) {
                                                  case 0:
                                                    return (
                                                      <Chip label="PENDING" />
                                                    );
                                                  case 1:
                                                    return (
                                                      <Chip label="APPROVED" />
                                                    );
                                                  default:
                                                    return (
                                                      <Chip label="DECLINED" />
                                                    );
                                                }
                                              })()}
                                            </TableCell>
                                            <TableCell style={{ width: "30%" }}>
                                              <p>
                                                {item.address}
                                                <br />
                                                {item.address2 != null
                                                  ? item.address2
                                                  : ""}
                                                <br />{item.mobile}
                                              </p>
                                            </TableCell>
                                            <TableCell
                                              style={{ minWidth: "100px" }}
                                            >
                                              <b>
                                                {item.total != null
                                                  ? `$${formatCurrency(item.total)}`
                                                  : "$0.00"}
                                              </b>
                                            </TableCell>
                                            <TableCell style={{ width: "30%" }}>
                                              <Link
                                                to={`/estimates/edit/${item.id}`}
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-primary pull-right mr-2"
                                                >
                                                  <EditIcon />
                                                </button>
                                              </Link>

                                              <Link
                                                to={`/estimates/view/${item.id}`}
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-primary pull-right mr-2"
                                                >
                                                  <b>Open</b>
                                                </button>
                                              </Link>
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                        </TableBody>
                                      </Table>
                                    </div>
                                  </div>
                                </div>
                              ))
                          ) : noResult ? (
                            <h4 style={{ padding: 100 }}>No results found!</h4>
                          ) : (
                            <h1></h1>
                          )
                        ) : (
                          <DivLoader>
                            <Loader
                              type="Oval"
                              color="#FC3538"
                              height={50}
                              width={50}
                            />
                          </DivLoader>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <DivPagination>
                    <Pagination
                      variant="text"
                      shape="circular"
                      classes={{ ul: paginations.ul }}
                      size="large"
                      page={selectedPage}
                      count={totalPages}
                      onChange={handlePagination}
                    />
                  </DivPagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
}
export default Estimate;
